type Button1 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const button1: Button1 = {
    'fontFamily': 'var(--plasma-typo-button1-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-button1-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-button1-font-style, normal)',
    'fontSize': 'var(--plasma-typo-button1-font-size, 1rem)',
    'letterSpacing': 'var(--plasma-typo-button1-letter-spacing, normal)',
    'lineHeight': 'var(--plasma-typo-button1-line-height, 1.25rem)'
};